import type { ReactNode } from 'react'
import { Link } from 'react-router-dom'

import { getUser } from '../../auth'
import { ThemeToggle, UserMenu } from '../../components/HeaderControls'
import { paths } from '../../routes'

/** Chrome for the customer portal: brand + the customer's company, theme,
 *  questionnaire help, and the user menu. Deliberately none of the staff
 *  header — no company list, no chat with company, no admin. */
export function PortalLayout({ children }: { children: ReactNode }) {
  const company = getUser()?.company_name
  return (
    <div className="app-layout">
      <header className="app-header">
        <Link to={paths.portal()} className="brand" aria-label="Your company home">
          <img src="/brand/allcode-logo.png" alt="AllCode" />
          <span className="product">Assessments</span>
        </Link>
        {company && (
          <span className="app-header__assessment" data-testid="portal-company-name">
            <Link to={paths.portal()} className="app-header__company">
              - {company}
            </Link>
          </span>
        )}
        <nav className="app-header__nav">
          <ThemeToggle />
          <Link to={paths.portalTeam()} data-testid="portal-team-link">
            Team
          </Link>
          <Link to={paths.questionnaireHelp()} data-testid="portal-help-link">
            Help
          </Link>
          <UserMenu />
        </nav>
      </header>
      <main className="app-main">{children}</main>
      <footer className="app-footer">© {new Date().getFullYear()} AllCode</footer>
    </div>
  )
}
